'use client';

import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { ContactTabContainer, ContactTabIcon, ContactTabTitle } from '../contact-tabs';

import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export function ContactTabsEshop({ opening1, opening2 }: { opening1: string; opening2: string }) {
  const generalLayout = useGlobalStore(state => state.generalLayout);
  const { t } = useTranslations();

  return (
    <ContactTabContainer>
      <div className="flex w-full items-start justify-between gap-4">
        <div className="flex w-full flex-col items-start justify-start gap-4">
          <ContactTabTitle title={t('text690')} />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <HtmlRendererRaw
              as="p"
              className="opening-hours text-sm font-light sm:text-base"
              html={opening1}
            />
            <HtmlRendererRaw
              as="p"
              className="opening-hours text-sm font-light sm:text-base"
              html={opening2}
            />
          </div>
        </div>
        <ContactTabIcon alt={t('text690')} imageUrl="/images/icons/opening-hours.svg" />
      </div>
      <Separator className="bg-black/5" />
      <div className="gap-4n flex w-full items-start justify-between">
        <div className="flex w-full flex-col items-start justify-start gap-4">
          <ContactTabTitle title={t('text360')} />
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <Link
              prefetch={false}
              href={`mailto:${generalLayout.contact?.email}`}
              target="_blank"
              className="textsm font-semibold text-primary transition-all hover:opacity-90 sm:text-base"
            >
              {generalLayout.contact?.email}
            </Link>
            <Link
              prefetch={false}
              href={`tel:${generalLayout.contact?.phone}`}
              target="_blank"
              className="textsm font-semibold text-primary transition-all hover:opacity-90 sm:text-base"
            >
              {generalLayout.contact?.phone}
            </Link>
          </div>
        </div>
        <ContactTabIcon alt={t('text360')} imageUrl="/images/icons/mobile.svg" />
      </div>
    </ContactTabContainer>
  );
}
